import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NavSubItemComponent } from '../nav-sub-item.component';
import { ProductGroupsSubNavItemViewModel } from './product-groups-sub-nav-item-view-model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-product-groups-sub-nav-item',
  templateUrl: './product-groups-sub-nav-item.component.html',
  styleUrls: ['./product-groups-sub-nav-item.component.scss', '../nav-sub-item.component.scss'],
  providers: [ProductGroupsSubNavItemViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ProductGroupsSubNavItemComponent extends NavSubItemComponent {
  constructor(
    public override viewModel: ProductGroupsSubNavItemViewModel,
    router: Router
  ) {
    super(viewModel, router);
  }
}
